import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { ContactForm } from "../components/Form";

export default function Contact() 
{
  const info = [
    { title: "A nos clients", desc: "Agrospace vous accompagne avec des produits de qualité, sûrs et conçus pour maximiser vos résultats. Intéressé par nos solutions ou un partenariat ? Notre équipe est à votre écoute pour répondre à vos besoins et concrétiser vos initiatives.", icon: "bi bi-check-circle-fill" },
    { title: "Solution applicative complète", desc: "Agrospace regroupe plusieurs applications complémentaires pour le secteur agricole. Jaari Chatbot agit comme un assistant intelligent, Agriteam un réseau social et Farm Space pour la gestion de ressoures et données des zones d'exploitation et bien d’autres encore.", icon: "bi bi-check-circle-fill" },
  ];

  return (
    <div className="bg-light min-vh-100">
      {/* Header's section */}
      <Header page={7} />

      {/* Edge controler section */}
      <div className="container-fluid bg-green-light d-flex justify-content-center align-items-center py-5 mb-5" id="edge" >
        <div className="row justify-content-center py-5">
          <div className="col-md-7 d-flex flex-column justify-content-center mb-lg-0">
            <p className="text-dark h1 fw-bold mb-3 text-center"> Agrospace contacts </p>
            <p className="lead text-muted mx-auto text-center">
              Découvrez comment Agrospace peut soutenir vos projets agricoles. Contactez-nous et bénéficiez d’un accompagnement personnalisé par notre équipe dédiée.
            </p>
          </div>
        </div>
      </div>


      {/* Form's section */}
      <div className="container-fluid py-5" >
        <div className="row justify-content-center py-5 px-2">
          {/* Text content on the left */}
          <div className="col-lg-4 mb-4 mb-lg-0 py-4">
            <p className="text-dark display-5 mb-3"> Envoyez nous des messages </p>
            <p className="lead text-muted mx-auto">
              Une fois votre message soumis, il sera pris en charge par notre équipe compétente, qui vous contactera ensuite pour le suivi.
            </p>
            <p className="lead text-success mx-auto">
              Nous encourageons particulièrement les messages relatifs aux partenariats, aux demandes d’éclaircissement ou à toute autre question pertinente.
            </p>
          </div>
          <div className="col-lg-2"></div>
          {/* Video placeholder on the right */}
          <div className="col-lg-5 border">
            <div className="d-flex flex-column py-5 px-2">       
               <ContactForm />
            </div>
          </div>
        </div>
      </div>


      {/* Bootom's section */}
      <div className="container-fluid bg-green-light py-5 mt-5" >
        <div className="row justify-content-center py-5">
          <div className="col-lg-10 mb-4">
            <div className="d-flex align-items-center flex-column">
              <h2 className=""> Pourquoi choisir Agrospace </h2>
              <p className="text-muted text-center"> Gérez, suivez et développez vos activités agricoles en toute confiance. </p>
            </div>
          </div>
            
          <div className="col-md-10 mt-4"> 
            <div className="row g-4">
              {info.map((item, idx) => (
                <div className="col-md-6" key={idx}>
                  <div className="d-flex flex-column mb-3 gap-2 border rounded-2 p-4 shadow-sm">
                    <div className="fs-4 text-success me-2">
                      <i className={item.icon}></i>
                    </div>
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer's section */}
      <Footer />
      
  </div>
  );
}
